import {  LoaderCover             } from "components/Covers/loadingCover";
import {  InfoMessageModal        } from "components/Covers/infoMessageModal";
import {  InfoMessageModalLocale  } from "components/Covers/infoMessageModalLocale";
import {  ActionConfirmationModal } from "components/Covers/confirmAction";
import {  InfoToast               } from "components/Covers/toastMessage";
import {  BtnExit                 } from "components/Covers/exitAction";

export const DynamicLayout = ({ children }) => {
    return (
      <>
        <LoaderCover/>
        <InfoMessageModal/>
        <InfoMessageModalLocale/>
        <ActionConfirmationModal/>
        <InfoToast/>
        <BtnExit/>
        { children }
      </>
    );
};
  